
<template>
  <!-- v-card class="fill-height" width="100vw" -->
  <v-row class="pt-0" style="height: 100%;">
    <Teleport to="#settings-group-header">
      Корпорации
    </Teleport>  
    <v-col cols="12">
      <CorporationList
        v-model="corporations"
        :corporations="corporations"
        :dealers="dealers"
        @onSearch="onSearch"
        @onAdd="addCorporation"
        @onGetList="getCorporationsList"
        @onClickRow="onClickRow"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Teleport from 'vue2-teleport'
import CorporationList from '../components/corporations/CorporationsList.vue'

export default{

  data:()=>({
    loading: false
  }),

  computed:{
    ...mapGetters('data', ['corporations', 'dealers'])
  },

  methods:{
    ...mapActions('data', ['corporations_list', 'dealer_list', 'corporation_create', 'corporation_search']),

    async addCorporation(corporation){
      this.loading = true;
      await this.corporation_create(corporation);
      await this.corporations_list();
      this.loading = false;
    },

    async getCorporationsList(options){
      this.loading = true;
      await this.corporations_list(options);
      this.loading = false;
    },

    onClickRow(item){
      this.$router.push({name: 'Corporation', params: {corporation_id: item.id}})
    },

    async onSearch(search){
      this.loading = true;
      if(search.query !== "")
        await this.corporation_search(search);
      else
        this.getCorporationsList();
      this.loading = false;
    }
  },

  async mounted(){
    this.loading = true;
    await this.corporations_list();
    await this.dealer_list();
    this.loading = false;
  },

  components: {
    CorporationList,
    Teleport
  }
}
</script>